import http from '@/api/http';

export async function login(login, password, code) {
    try {
        let param = ''

        if (code) {
            param = '?code=' + code
        }

        const response = await http.get('api/v1/auth' + param, { headers: { 'Authorization': 'Basic ' + btoa(login + ":" + password), 'Content-Type': 'application/json', } })
        
        return response.data
    } catch (error) {
        console.log(error.response)
        return error.response.data
    }
}

export async function register(data) {
    try {
        let dataPram = {
            'username': data.username,
            'first_name': data.first_name,
            'last_name': data.last_name,
            'mail': data.mail,
            'password': data.password 
        }
        if (data.code) {
            dataPram["code"] = data.code
        }
        const response = await http.post('api/v1/register',
            dataPram,
            {
                headers: {
                    'Content-Type': 'multipart/form-data',
                }
            })
        // commit('SET_USER_DATA', response.data)
        return response.data

    } catch (error) {
        console.log(error.response)
        return error.response.data
    }
}

export async function activate(key) {
    try {
        const response = await http.get('api/v1/register/new?key=' + key, {
            headers: { 'Content-Type': 'application/json', }
        })

        return response.data

    } catch (error) {
        console.log(error.response)
        return null
    }
}

export async function resendCode(email) {
    try {
        const dataPram = {
            mail: email
        }
        const response = await http.post('api/v1/register/two-active', 
            dataPram,
            {
                headers: { 'Content-Type': 'multipart/form-data' }
            }
        )

        return response.data

    } catch (error) {
        console.log(error.response)
        return error.response.data
    }
}

export async function restore(email) {
    try {
        let dataPram = {
            'mail': email
        }

        const response = await http.post('api/v1/register/recovery-pass', 
            dataPram, 
            { 
                headers: { 'Content-Type': 'multipart/form-data' } 
            }
        )

        return response.data

    } catch (error) {
        console.log(error.response)
        return null
    }
}

export async function setData(token) {
    try {
        const response = await http.get('api/v1/user', {
            headers: { 'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json', }
        })

        return response.data

    } catch (error) {
        console.log(error.response)
        return null
    }
}

export async function recentProjects(token) {
    try {
        const response = await http.delete('api/v1/user/open-project', {
            headers: { 'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json', }
        })

        return response.data
    } catch (error) {
        console.log(error.response)
        return null
    }
}

export async function userInfo(token) {
    try {
        const response = await http.get('api/v1/user', {
            headers: { 'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json', }
        })

        return response.data
    } catch (error) {
        console.log(error.response)
        return null
    }
}

export async function changePassword(token, data) {
    try {
        let dataPram = {
            'pass_old': data.old,
            'pass_new': data.new,
            'pass_new_two': data.new2
        }

        // console.log(dataPram);
        const response = await http.post('api/v2/setting/user-pass',
            dataPram,
            { headers: {'Authorization': 'Bearer ' + token, 'Content-Type': 'multipart/form-data'} })

        return response.data

    } catch (error) {
        console.log(error.response)
        return error.response.data
    }
}

export async function saveSettings(token, data) {
    try {
        let dataPram = {
            'first_name': data.first_name,
            'last_name': data.last_name,
            'lang': data.lang
        }

        // console.log(dataPram);
        const response = await http.post('api/v2/setting/user',
            dataPram,
            { headers: {'Authorization': 'Bearer ' + token, 'Content-Type': 'multipart/form-data'} })

        return response.data.length == 0 ? true : false

    } catch (error) {
        console.log(error.response)
        return false
    }
}

export async function uploadAvatar(token, data) {
    try {
        const response = await http.post('api/v1/user/image', data,
            {
                headers: { 
                    'Authorization': 'Bearer ' + token, 
                    'Content-Type': 'multipart/form-data'
                }
            })
        return response.data
    } catch (error) {
        console.log(error.response)
        return null        
    }
}
export async function removeAvatar(token, id) {
    try {
        const response = await http.delete('api/v1/user/image?id=' + id, {
            headers: { 'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json' }
        })
        return response.data
    } catch (error) {
        console.log(error.response)
        return null
    }
}